var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.345,
    height: 10.753,
    viewBox: "0 0 11.345 10.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error-svgrepo-com",
    d: "M8.173,2.32a.591.591,0,0,0-1,0l-5.1,9.642a.567.567,0,0,0,.5.833h10.21a.566.566,0,0,0,.5-.832Zm.066,8.774H7.1V9.959H8.239ZM7.1,8.824V5.988H8.239V8.824Z",
    transform: "translate(-1.999 -2.042)",
    fill: "#c8321a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfoIcon);
export default __webpack_public_path__ + "static/media/alert-info-icon.9839a6d68608c9d2f75d69c377284c86.svg";
export { ForwardRef as ReactComponent };